import { c as _c } from "react/compiler-runtime";
import { Icon, IconSize } from '@/components/Atoms/Icon/Icon';
import Duration from '@/components/Icons/Duration';
import useTranslation from '@/hooks/useTranslation';
import type { TimeHTMLAttributes } from 'react';
import type { FCh, FCl } from 'react-fc';
import styled from 'styled-components';
export const TimeDuration: FCl<IProps> = t0 => {
  const $ = _c(46);
  let className;
  let durationInSeconds;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      durationInSeconds,
      withIcon: t1,
      asAddendum: t2,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = durationInSeconds;
    $[3] = rest;
    $[4] = t1;
    $[5] = t2;
  } else {
    className = $[1];
    durationInSeconds = $[2];
    rest = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const withIcon = t1 === undefined ? false : t1;
  const asAddendum = t2 === undefined ? false : t2;
  const {
    t
  } = useTranslation();
  let isoHour;
  let isoMin;
  let t3;
  let timeDuration;
  if ($[6] !== asAddendum || $[7] !== className || $[8] !== durationInSeconds || $[9] !== rest || $[10] !== t) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      timeDuration = [];
      const durationInMinutes = Math.floor(durationInSeconds / 60);
      const minutes = durationInMinutes % 60;
      const hours = (durationInMinutes - minutes) / 60;
      const seconds = durationInSeconds - minutes * 60 - hours * 60 * 60;
      isoMin = "";
      isoHour = "";
      if (hours > 7) {
        const days = Math.ceil(hours / 24);
        const t4 = `P${days}D`;
        let t5;
        if ($[15] !== days || $[16] !== t) {
          t5 = t("TimeDuration.day", {
            count: days
          });
          $[15] = days;
          $[16] = t;
          $[17] = t5;
        } else {
          t5 = $[17];
        }
        let t6;
        if ($[18] !== asAddendum || $[19] !== t5) {
          t6 = <Text asAddendum={asAddendum}>{t5}</Text>;
          $[18] = asAddendum;
          $[19] = t5;
          $[20] = t6;
        } else {
          t6 = $[20];
        }
        let t7;
        if ($[21] !== className || $[22] !== rest || $[23] !== t4 || $[24] !== t6) {
          t7 = <time className={className} dateTime={t4} {...rest}>{t6}</time>;
          $[21] = className;
          $[22] = rest;
          $[23] = t4;
          $[24] = t6;
          $[25] = t7;
        } else {
          t7 = $[25];
        }
        t3 = t7;
        break bb0;
      }
      if (hours > 0) {
        let t4;
        if ($[26] !== hours || $[27] !== t) {
          t4 = t("TimeDuration.h", {
            count: hours
          });
          $[26] = hours;
          $[27] = t;
          $[28] = t4;
        } else {
          t4 = $[28];
        }
        timeDuration.push(t4);
        isoHour = `${hours}H`;
      }
      if (minutes > 0) {
        isoMin = `${minutes}M`;
        let t4;
        if ($[29] !== minutes || $[30] !== t) {
          t4 = t("TimeDuration.m", {
            count: minutes
          });
          $[29] = minutes;
          $[30] = t;
          $[31] = t4;
        } else {
          t4 = $[31];
        }
        timeDuration.push(t4);
      }
      if (seconds > 0) {
        isoMin = `${seconds}S`;
        let t4;
        if ($[32] !== seconds || $[33] !== t) {
          t4 = t("TimeDuration.s", {
            count: seconds
          });
          $[32] = seconds;
          $[33] = t;
          $[34] = t4;
        } else {
          t4 = $[34];
        }
        timeDuration.push(t4);
      }
    }
    $[6] = asAddendum;
    $[7] = className;
    $[8] = durationInSeconds;
    $[9] = rest;
    $[10] = t;
    $[11] = isoHour;
    $[12] = isoMin;
    $[13] = t3;
    $[14] = timeDuration;
  } else {
    isoHour = $[11];
    isoMin = $[12];
    t3 = $[13];
    timeDuration = $[14];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  const t4 = `PT${isoHour}${isoMin}`;
  let t5;
  if ($[35] !== withIcon) {
    t5 = withIcon && <Icon use={<Duration />} size={IconSize.TEXT} />;
    $[35] = withIcon;
    $[36] = t5;
  } else {
    t5 = $[36];
  }
  const t6 = timeDuration.join(" ");
  let t7;
  if ($[37] !== asAddendum || $[38] !== t5 || $[39] !== t6) {
    t7 = <Text asAddendum={asAddendum}>{t5}{t6}</Text>;
    $[37] = asAddendum;
    $[38] = t5;
    $[39] = t6;
    $[40] = t7;
  } else {
    t7 = $[40];
  }
  let t8;
  if ($[41] !== className || $[42] !== rest || $[43] !== t4 || $[44] !== t7) {
    t8 = <StyledTime className={className} dateTime={t4} {...rest}>{t7}</StyledTime>;
    $[41] = className;
    $[42] = rest;
    $[43] = t4;
    $[44] = t7;
    $[45] = t8;
  } else {
    t8 = $[45];
  }
  return t8;
};
const Text: FCh<{
  asAddendum: IProps['asAddendum'];
}> = t0 => {
  const $ = _c(4);
  const {
    asAddendum,
    children
  } = t0;
  const t1 = asAddendum && "(";
  const t2 = asAddendum && ")";
  let t3;
  if ($[0] !== children || $[1] !== t1 || $[2] !== t2) {
    t3 = <>{t1}{children}{t2}</>;
    $[0] = children;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
interface IProps extends TimeHTMLAttributes<HTMLTimeElement> {
  durationInSeconds: number;
  withIcon?: boolean;
  asAddendum?: boolean;
}
const StyledTime = styled.time`
    display: inline-flex;
    align-items: center;
    gap: var(--size-grid-half);
`;